import { parseCliJson } from '@cli-utils/process.js'

export function parseRailwayJson<T = unknown>(output: string): T | undefined {
  return parseCliJson<T>(output)
}
